module.exports = __webpack_public_path__ + "img/Lupe.73112f32.png";